import { IStyles } from '../models/app/IStyles';

export const STYLES: IStyles = {
	components: {
		app: {
			children: {
				wrapper: {
				},
			},
		},
		barChart: {
			children: {
				wrapper: {
					padding: {
						bottom: '100px',
					},
				},
			},
		},
	},
	theme: {
		base: {
			application: {
				font: {
					family: 'Arial',
				},
			},
			table: {
				width: '100%',
				overrides: [
					{
						selector: '[data-selector="base-tooltip-tooltipContent"]',
						style: {
							color: 'black',
							lineHeight: '14px',
							font: {
								size: '12px',
								weight: 'normal',
							},
						},
					},
					{
						selector: 'li[data-selector="base-list-listItemWrapper"]',
						style: {
							padding: {
								_value: '10px',
							},
							border: {
								bottom: {
									_value: '1px solid #c7c7c7',
								},
							},
						},
					},
					{
						selector: 'li[data-selector="base-list-listItemWrapper"] div',
						style: {
							border: {
								_value: 'none',
							},
						},
					},
					{
						selector: 'li[data-selector="base-list-listItemWrapper"][data-multipart="false"]:nth-child(1)',
						style: {
							font: {
								weight: 'bold',
							},
							color: '#228de2',
							border: {
								bottom: {
									width: '2px',
									style: 'solid',
									color: '#228de2',
								},
							},
						},
					},
				],
				children: {
					table: {
						width: '100%',
						font: {
							family: 'Arial',
						},
					},
					head: {
						color: '#000000',
						overrides: [
							{
								selector: 'tr:nth-child(2) th',
								style: {
									border: {
										bottom: {
											_value: `2px solid #008de0`,
										},
									},
								},
							},
						],
					},
					headRow: {
						height: '55px',
					},
					headCell: {
						padding: {
							right: '16px',
						},
						text: {
							align: 'left',
						},
						font: {
							size: '16px',
							weight: 'bold',
						},
						lineHeight: '20px',
						overrides: [
							{
								selector: '[data-selector="base-sortButton-wrapper"]',
								style: {
									float: 'right',
									overrides: [
										{
											selector: 'button',
											style: {
												border: {
													_value: 'none',
												},
												background: {
													color: 'transparent',
												},
												overrides: [
													{
														selector: 'img',
														style: {
															width: '16px',
															height: '16px',
														},
													},
												],
											},
										},
									],
								},
							},
						],
					},
					headCellSubTitle: {
						font: {
							size: '12px',
							weight: 'normal',
						},
						lineHeight: '16px',
					},
					body: {
						font: {
							size: '10px',
						},
						color: '#001928',
						lineHeight: '24px',
					},
					row: {
						height: '40px',
						background: {
							color: '#FFFFFF',
						},
					},
					cell: {
						border: {
							bottom: {
								color: '#C7C7C7',
								width: '1px',
								style: 'solid',
							},
						},
						selectors: [
							{
								':first-child': {
									text: {
										align: 'left',
									},
									padding: {
										left: '16px',
									},
								},
							},
						],
						text: {
							align: 'left',
						},
						padding: {
							right: '16px',
						},
					},
					disclaimersWrapper: {
						margin: {
							top: '20px',
						},
					},
					card: {
						margin: {
							_value: '4px',
						},
						padding: {
							_value: '4px',
						},
					},
					listGroupTitle: {
						font: {
							weight: 'bold',
						},
					},
					listGroupSubTitle: {
						display: 'block',
						color: 'grey',
						font: {
							weight: 'normal',
						},
					},
				},
			},
			list: {
				padding: {
					_value: '0',
				},
				listStyle: {
					type: 'none',
				},
				overrides: [
					{
						selector: '[data-selector="base-list-listItemWrapper"]:nth-child(1)',
						style: {
							border: {
								bottom: {
									width: '2px',
									style: 'solid',
									color: '#0079C1',
								},
							},
						},
					},
					{
						selector: 'li[data-multipart="false"]:nth-child(1) div[data-selector="base-list-content"]',
						style: {
							color: '#0079C1',
						},
					},
				],
				children: {
					multipartListItem: {
						display: 'flex',
						padding: {
							_value: '4px',
						},
						border: {
							bottom: {
								_value: '1px solid #C7C7C7',
							},
						},
					},
					content: {
						flex: {
							_value: 'auto',
						},
						padding: {
							_value: '4px',
						},
						font: {
							size: '12px',
							weight: 'normal',
						},
						lineHeight: '14px',
						border: {
							bottom: {
								width: '1px',
								style: 'solid',
								color: '#0079C1',
							},
						},
					},
					firstContent: {
						flex: {
							_value: 'auto',
						},
					},
					lastContent: {
						flex: {
							grow: '0',
						},
					},
				},
			},
		},
		charting: {
			chartBase: {
				height: '500px',
			},
			barChart: {
				font: {
					family: 'Arial',
					size: '11px',
				},
				color: '#001928',
				overrides: [
					{
						selector: 'div.recharts-wrapper > svg > g.recharts-layer.recharts-cartesian-axis.recharts-yAxis.yAxis > g text',
						style: {
							fill: '#001928',
						},
					},
					{
						selector: 'div.recharts-wrapper > div > ul > li.recharts-legend-item > svg',
						style: {
							margin: {
								right: '12px !important',
							},
							width: '12px',
							height: '12px',
						},
					},
				],
			},
		},
	},
};